// Photo Drop (owner ruling 2026-10-25, #18893): the ONE look for a "your photo"
// spot — a dashed circle reading "Drop Photo", or the photo itself. The server
// renders it from the same classes; every client-side swap (a fresh upload, Remove
// Photo, a photo that fails to load) builds it from here so the three never drift.
export const PHOTO_DROP_LABEL = "Drop Photo"
export const PHOTO_DROP_IMG_CLASSES = ["gl-profile-avatar-img", "gl-photo-drop__img"]

export const PHOTO_DROP_PLACEHOLDER_HTML =
  '<div class="gl-profile-avatar-placeholder gl-photo-drop__empty">' +
  '<i class="ph ph-user" aria-hidden="true"></i>' +
  `<span>${PHOTO_DROP_LABEL}</span></div>`

export function buildPhotoDropPlaceholder() {
  const template = document.createElement("template")
  template.innerHTML = PHOTO_DROP_PLACEHOLDER_HTML
  return template.content.firstElementChild
}
